import { apiClient } from "../../../../utils/api";
import { services } from "../../../../constants/services";

export const UpdateEnvironmentValuesService = async (data: {
  environmentParameterValueId: number;
  value: string;
}[]): Promise<any> => {
  return await apiClient.put(`${services["environment-variables"]}/update-values`, data);
};